import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Modal from "react-modal";
import "./assets/styles/stylesTailwind.css";

import { ThemeProvider } from "./hooks/ThemeContext";
import { UserProvider } from "./hooks/UserContext";
import { CartProvider } from "./hooks/CartContext";
import { GlobalStyle } from "./hooks/globalStyle";

Modal.setAppElement("#root");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <UserProvider>
        <CartProvider>
          <App />
          <GlobalStyle />
        </CartProvider>
      </UserProvider>
    </ThemeProvider>
  </React.StrictMode>
);
